import React, {useEffect, useState} from "react";
import s from './SoundDemosActivatedPrompt.module.scss';
import {GenericModal} from "../../common/genericModal/GenericModal";
import Checkbox from "../../common/tools/Checkbox/Checkbox";
import {lessonPlayerStore} from "../../../redux/lesson/LessonPlayerStore";
import {useAppSelector} from "../../../redux/hooks";

export default function SoundDemosActivatedPrompt() {
  const canShowDemoSoundActivatedPrompt = useAppSelector(lessonPlayerStore.getCanShowDemoSoundActivatedPrompt);
  const isPromptAllowedByUser = useAppSelector(lessonPlayerStore.getDemoSoundActivatedPromptIsAllowedByUser);
  const isDemoModeOn = lessonPlayerStore.getIsDemoLeftHandSoundEnabled() || lessonPlayerStore.getIsDemoRightHandSoundEnabled();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    setIsOpen(isPromptAllowedByUser && isDemoModeOn && canShowDemoSoundActivatedPrompt);
  }, [isPromptAllowedByUser, isDemoModeOn, canShowDemoSoundActivatedPrompt]);

  if (!isOpen) {
    return null;
  }

  let localIsPromptAllowedByUser: boolean = isPromptAllowedByUser;

  return (
    <GenericModal
      canShow={(): boolean => {
        return isOpen;
      }}
      backgroundColor={"white"}
      title={"Piano sound demos activated"}
      onClose={() => {
        lessonPlayerStore.setCanShowDemoSoundActivatedPrompt(false);
        lessonPlayerStore.setDemoSoundActivatedPromptIsAllowedByUser(localIsPromptAllowedByUser);
      }}
    >
      <div className={s.container}>
        <div className={s.topText}>
          <p><strong>Piano sound demos</strong> let you hear how the notes should sound on the piano &mdash; one of Playground&apos;s best learning tools.</p>
          <p><strong>Turning piano demos on disables mic scoring.</strong> You can re-enable scoring by turning the demo sounds off.</p>
        </div>

        <div className={s.checkBoxSection}>
          <Checkbox
            name={`enableSoundDemoActivatedCheckbox`}
            isChecked={!localIsPromptAllowedByUser}
            label={`Don't show this again`}
            onChange={(isChecked: boolean) => {
              localIsPromptAllowedByUser = !isChecked;
            }}
          />
        </div>
      </div>
    </GenericModal>
  );
}